import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
export default tsx.componentFactoryOf().create({
    name: 'catch-error',
    props: {
        capture: p(Boolean).default(false),
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data() {
        return {
            error: null,
        };
    },
    methods: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        reset() {
            this.error = null;
            tsx.emitOn(this, 'onReset');
        },
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    errorCaptured(error) {
        this.error = error;
        tsx.emitOn(this, 'onError', error);
        return this.capture ? false : undefined;
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render() {
        return this.$scopedSlots.default({
            error: this.error,
            resetError: this.reset,
        });
    },
});
